const HTML_PATTERN = /<([a-z]+)([^<]+)*>/i;

export function toUserFacingError(raw: string | undefined | null, fallback = 'Something went wrong. Please try again.') {
  if (!raw) {
    return fallback;
  }

  const trimmed = raw.trim();
  const looksLikeHtml = HTML_PATTERN.test(trimmed) && (trimmed.startsWith('<!') || trimmed.startsWith('<html'));

  if (looksLikeHtml) {
    return 'The service is temporarily unavailable. Please try again shortly.';
  }

  try {
    const parsed = JSON.parse(trimmed);

    if (typeof parsed === 'string') {
      return parsed;
    }

    if (parsed?.detail) {
      if (typeof parsed.detail === 'string') {
        return parsed.detail;
      }
      if (Array.isArray(parsed.detail)) {
        return parsed.detail.join(' ');
      }
      // Structured refusals from the server-side plan gate ({code: 'feature_locked', message, upgrade_to})
      if (typeof parsed.detail === 'object' && typeof parsed.detail.message === 'string') {
        return parsed.detail.message;
      }
    }

    if (parsed?.message && typeof parsed.message === 'string') {
      return parsed.message;
    }

    if (parsed?.error && typeof parsed.error === 'string') {
      return parsed.error;
    }
  } catch {
    // Fall through to return trimmed text when JSON parsing fails
  }

  return trimmed.length <= 200 ? trimmed : fallback;
}
